<template>
    <div class="app-content">
		<transition name="el-fade-in-linear">
	    	<div v-show="promptShow" class="back">
	    		<div v-show="promptShow" class="copyLink">
	    			<h1>提示</h1>
	    			<p>{{ promptContent }}</p>
	    			<button v-if="promptValue == 'copy'" @click="copyLink">复 制</button>
					<button v-else @click="promptShow = false">确 定</button>
	    		</div>
	    	</div>
	    </transition>
		<div class="logo">
			<img src="../../assets/logo/logo.jpg" alt="">
		</div>
		<div class="center">
			<h1>实践技能训练</h1>
			<h2>技能实践考试</h2>
			<!-- <button @click="download">立即下载</button> -->
			<div class="downloadButton" v-if="isShowOpenApp">
        <!-- <div class="downloadButton" @click="download">立即下载</div> -->
              <span class="openApp2Font">打开app</span>
              <div class="openAppStyle">
                <wx-open-launch-app id="openApp2" style=" position: absolute;top: 0; left:0;width:100%;height: 100%;" appid="wx35f164d814467bdc" :extinfo="extinfoCon"  @launch="AppLaunch" @error="AppError" >
                  <component is="script" type="text/wxtag-template">
					<div style=" position: absolute;top:0;left:0;width: 96%;height: 100%;border:none;background-color:transparent;"></div>
                  </component>
                </wx-open-launch-app>
              </div>
            </div>
            <div class="downloadButton" @click="download" v-else>立即下载</div>
		</div>
		<div class="zhezhao" v-if="dialog">
          <img src="../../assets/images/zhezhao.png" alt="">
        </div>
    </div>
</template>
<script>
import store from '@/store'
import wx from 'weixin-js-sdk'
import CryptoJS from "crypto-js";
import axios from 'axios'
  export default{
    name:"transfer",
    data(){
        return{
            promptShow: false,
			promptValue: '',
			promptContent: '',
			timer:null,
			isShowOpenApp: false,
			extinfoCon:"ydddoctor://startup",
			dialog: false,
        }
    },
    created(){
		store.dispatch('settings/setTitle', '银成圣云执业医师考试')
		let ua = navigator.userAgent.toLowerCase();
		if (ua.match(/MicroMessenger/i) == "micromessenger") {
			// this.ejectPrompt('copy')
			this.isShowOpenApp = true;
            this.getApp();
		} else {
			this.closeWeb()
		}
    },
	// mounted(){
	// 	const timer = setTimeout(() => {
	// 		console.log('11111');
	// 		// this.download();
	// 		alert('提示')
	// 	}, 3000);
	// 	document.addEventListener("visibilitychange", visibilitychange, false);
	// 	document.addEventListener("webkitvisibilitychange", visibilitychange, false);
	// 	window.addEventListener("pagehide",function() {
	// 		clearTimeout(timer);
	// 	},
	// 	false
	// 	)
	// 	function visibilitychange() {
	// 		const tag = document.hidden || document.webkitHidden;
	// 		tag && clearTimeout(timer);
	// 	}

	// },
    methods:{
		butLister2(){
      let btn2 = document.getElementById("openApp2");
      btn2.addEventListener('ready', function (e) {
        // js中，我是在这里添加的extinfo内容，
        console.log("ready")
      })
      btn2.addEventListener('launch', function (e) {
        console.log("launch")
      })
      btn2.addEventListener('error', (e)=> {
        if(e.detail){
          if(this.judgeClient() == "IOS"){
            window.location.href =
            "https://apps.apple.com/us/app/执业医师考试-执业医师/id6469769193";

          }else{
            this.dialog = true;
          }
        }
        console.log("error")
      })

    },
    getApp(){
      axios.get('https://www.medmeta.com/api/wechat/wx/jsapi/wx73d5eb8e6d65981e/getJsapiTicket').then( res => {
        console.log("???????",res);
        if(res!=null){
          let that = this;
          let url = window.location.href;
          console.log(url)
          url = url.split('#')[0]
          
          let tick = res.data;
          let time = parseInt(new Date().getTime()/1000);
          let nums = this.suijione(true,true,false,16);
          
          let str = 'jsapi_ticket='+ tick + '&noncestr='+ nums  +'&timestamp='+ time + '&url='+ url;
          
          let signature = CryptoJS.SHA1(str).toString();
          let appid = "wx73d5eb8e6d65981e"
          console.log("测试数据",tick,time,nums,str,signature,appid)
          wx.config({
            debug: false,
            appId: appid,  // 此处APPID为公众号的APPID
            timestamp: time, 
            nonceStr: nums, 
            signature: signature,
            jsApiList: ['wx-open-launch-app','onMenuShareTimeline'], //此处必须填写一个，不为null就行
            openTagList: ['wx-open-launch-app'] 
          })
          wx.ready( () => {
            console.log('ready')
            wx.checkJsApi({
              jsApiList: ['wx-open-launch-app'], // 校验跳转APP的标签是否可用
              uccess: function (res) {
                console.log('可用')
                  onsole.log('config111')
              },
              fail: (err) => {
                console.log(err, '不可用')
              }
            });
            that.butLister2();
          }) 
          wx.error(function(res){
            alert("11111",res)
            console.log("error：",res)
          });
            
        }
      })
    },

    AppLaunch(e){
	  	// this.copyLink();
	  },
	  AppError(e){
	  	console.log("fail",e.detail)
	  },
    // 监听error 函数
	handleErrorFn (e) {
	  // 跳转失败
	  console.log(JSON.stringify(e), '跳转失败')
	  download() // 这里跳转App下载页面
	},
    // 监听launch 函数
    handleLaunchFn (e) {
      // 跳转成功
      console.log(JSON.stringify(e), '跳转成功')
    },
    getRandom(a,b){
      var max = a;
      var min = b;
      if(a<b){
        max = b;
        min = a;
      }
      return parseInt(Math.random()*(max-min))+min;
    },
    suijione(num,maxA,minlA,fqy){
      let arr=[]
      let arr1=[]
      let arr2=[]
      if(num){
        for(let m=0;m<=9;m++){
          arr.push(m)
        }
      }
      if(maxA){
        for(let m=65;m<=90;m++){
          arr1.push(m)
        }
      }
      if(minlA){
        for(let m=97;m<=122;m++){
          arr2.push(m)
        }
      }
      if(!fqy){
        console.log('生成位数必传')
      }
      let mergeArr = arr.concat(arr1);
      let mergeArr1 = mergeArr.concat(arr2);
      let _length=mergeArr1.length
      let text=''
      for(let m=0;m<fqy;m++){
        let text1=''
        let random= this.getRandom(0,_length)
        if((mergeArr1[random])<=9){
          text1=mergeArr1[random]
        }else if((mergeArr1[random])>9){
          text1=String.fromCharCode(mergeArr1[random])
        }
        text+=text1
      }
      return text
    },

		ejectPrompt(val,content){
			if (val == 'copy') {
				this.promptContent = '请复制链接地址，去外部浏览器中打开'
			    this.promptShow = true
			    this.promptValue = val
			} else {
				this.promptContent = content
				this.promptShow = true
			    this.promptValue = val
			}
		},

		copyLink(){
			let copyInput = document.createElement("input"); // 创建元素
	        // 这边为链接地址
	        copyInput.value = 'https://www.syyxcloud.com/clinical/#/jump';
	        document.body.appendChild(copyInput); // 添加元素
	        copyInput.select();
	        document.execCommand("Copy"); // 执行浏览器复制命令
            document.body.removeChild(copyInput); // 移除刚创建的元素
	        this.$message.success("复制成功");
			this.promptShow = false
		},

		download() {
			let ua = navigator.userAgent.toLowerCase();
		    if (ua.match(/MicroMessenger/i) == "micromessenger") {
				this.ejectPrompt('copy')
		    } else { 
		    	if (this.judgeClient()=='Android') {
				//   window.location.href = 'https://file.medmeta.com/static/20231129/doctorapp.apk'
				  window.location.href = 'https://sj.qq.com/appdetail/com.yddmi.doctor'
			    } else if (this.judgeClient()=='IOS') {
			    	window.location.href = 'https://apps.apple.com/us/app/执业医师考试-执业医师/id6469769193'
					// this.ejectPrompt('prompt','暂未上架苹果商店，敬请期待')
			    } else {
    
			    }
		    }
		},

		closeWeb() {
			// alert(this.judgeClient())
            if (this.judgeClient()=='Android') {
				this.closeWebAndroid()
			} else if (this.judgeClient()=='IOS') {
				this.closeWebIOS()
			} else {

			}
        },

        closeWebAndroid() {
			window.location.href = 'openapp://syyxcloud.com'
        },

        closeWebIOS() {
            window.location.href = 'ydd9528://'
        },
		
		judgeClient() {
          let u = navigator.userAgent;
          let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;   //判断是否是 android终端
          let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);  //判断是否是 iOS终端
          if(isAndroid){
            return 'Android';
          }else{
            return 'IOS';
          }
        },
    }
}
</script>
<style lang="scss" scoped>
.app-content {
	width: 100%;
	height: 100%;
	position: relative;
	text-align: center;
	padding-top: 3.2rem;

	.back {
		position:absolute;
        left:0;
        top:0;
        width:100%;
        height:100%;
        background: rgba(0,14,14,0.5);
		z-index: 9;
		display: flex;
		align-items: center;
		justify-content: center;
        backdrop-filter: blur(1px);
		.copyLink {
	    	width: 7.7333rem;
	    	// height: 4.8rem;
	    	background-color: #fff;
	    	border-radius: .1067rem;
			h1 {
				font-size: .48rem;
				font-weight: 500;
				margin-top: .5333rem;
				color: #545454;
				padding: 0 .4rem 0 .4rem;
				text-align: center;
			}
			p {
				font-size: .4267rem;
				margin-top: .4rem;
				color: #b2b2b2;
				padding: 0 .4rem 0 .4rem;
				text-align: center;
			}
			button {
				width: 100%;
				height: 1.3333rem;
				margin-top: .6667rem;
				border: 0;
				border-top: 1px solid #efefef;
				border-radius: 0rem;
				background-color: #fff;
				font-size: .5333rem;
				font-weight: 600;
				color: #4ec39f;
				border-radius: 0 0 .1067rem .1067rem;
				z-index: 88;
			}
	    }
	}

	.logo {
		width: 100%;
		display: flex;
		justify-content: center;
		img {
			width: 1.92rem;
			height: 1.92rem;
		}
	}
	.center {
		width: 100%;
		height: 11.0933rem;
		background: url('../../assets/images/back.png');
		background-size: 100%;
		h1 {
			font-size: .64rem;
            font-family: PingFangSC-Medium, PingFangSC-Medium;
            color: #121212;
			font-weight: normal;
            letter-spacing: .16rem;
			text-align: center;
			margin-top: .6667rem;
		}
		h2 {
			font-size: .4267rem;
            font-family: PingFangSC-Regular, PingFangSC-Regular;
            font-weight: normal;
            color: #666666;
            letter-spacing: .1067rem;
			text-align: center;
			margin-top: .4rem;
		}
		.downloadButton {
	    	width: 6.4rem;
	    	height: 1.28rem;
			line-height: 1.28rem;
			margin: 0 auto;
			margin-top: 5.3333rem;
	    	background-color: #D3241C;
	    	border: 0rem;
	    	text-align: center;
	    	border-radius: .1067rem;
	    	font-size: .48rem;
	    	font-family: PingFangSC-Medium, PingFangSC-Medium;
	    	font-weight: normal;
            color: #FFFFFF;
			position: relative;
			.openAppStyle {
				width: 6.4rem;
              height: 1.28rem;
              position: absolute;
              top: 0;
              left: 0;
              #openApp,#openApp2{
                width:100%;
                height:100%;
                div{
                  width:100%;
                  height:100%;
                  button{
                    width:100%;
                    height:100%;
                  }
                }
              }
              #openApp2{
                width: 6.4rem;
                height: 1.28rem;
              }
            }
	    }
	}
	.zhezhao {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
  
      img {
        width: 100%;
        height: 100%;
      }
    }
}
</style>